export const priceWithSpace = (p: Number) => p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')